import IMessage from '../../FrontApplet/IMessage';
import IPostMessage from '../../FrontApplet/IPostMessage';

export default interface Exchange<TResponse> {
	postMessage: IPostMessage<TResponse>;
	messageNameToType(name: string): string;
	createNamespaced<TNamespacedResponse>(namespace: string): Exchange<TNamespacedResponse>;
}

export function createExchange<TResponse>(messagePrefix: string, postMessage: IPostMessage<any>): Exchange<TResponse> {
	const messageNameToType = (name: string) => {
		return [messagePrefix, name].join('.');
	};
	const typedPostMessage = async (message: IMessage): Promise<TResponse> => {
		const type = messageNameToType(message.type);
		message = {
			...message,
			type,
		};
		return postMessage(message);
	};
	return {
		messageNameToType,
		postMessage: typedPostMessage,
		createNamespaced: (namespace: string) => createExchange(messageNameToType(namespace), postMessage),
	};
}
